exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background-color:#295079}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/hronologija/1941/05-01/stil.css
// module id = 27
// module chunks = 0